const SIDE_PANEL = "SIDE_PANEL";
export const UPDATE_PANEL_OPENED_STATE = `${SIDE_PANEL}/UPDATE_PANEL_OPENED_STATE`;
export const RESET_PANEL_OPENED_STATE = `${SIDE_PANEL}/RESET_PANEL_OPENED_STATE`;
